import { persistentPageConfig } from './page-config'

// P0保持旧 metadata/config.detail/config.component 协议，禁止用执行代码兜底解析。
export class LegacyConfigError extends Error {
  constructor (field, message) {
    super(`${field}：${message}`)
    this.name = 'LegacyConfigError'
    this.field = field
  }
}

export const cloneConfig = value => JSON.parse(JSON.stringify(value))
const isObject = value => value !== null && typeof value === 'object' && !Array.isArray(value)

function parseField (value, field, fallback) {
  if (value === undefined || value === null || value === '') return cloneConfig(fallback)
  if (typeof value !== 'string') return cloneConfig(value)
  try {
    return JSON.parse(value)
  } catch (error) {
    throw new LegacyConfigError(field, '不是有效的JSON，请修复配置后重试；原数据没有被覆盖')
  }
}

function assertObject (value, field) {
  if (!isObject(value)) throw new LegacyConfigError(field, '必须是对象')
}

function assertDimensions (config) {
  for (const key of ['width', 'height']) {
    if (!Number.isFinite(Number(config[key])) || Number(config[key]) <= 0) {
      throw new LegacyConfigError(`config.detail.${key}`, '画布尺寸必须是大于0的有限数值')
    }
  }
}

function assertNodes (nodes, field = 'config.component', depth = 0) {
  if (!Array.isArray(nodes)) throw new LegacyConfigError(field, '必须是组件数组')
  if (depth > 50) throw new LegacyConfigError(field, '组件嵌套层级过深')
  nodes.forEach((node, index) => {
    const location = `${field}[${index}]`
    assertObject(node, location)
    if (node.children !== undefined) assertNodes(node.children, `${location}.children`, depth + 1)
    else assertObject(node.component, `${location}.component`)
  })
}

export function readLegacyProject (record, defaults = {}) {
  assertObject(record, 'project')
  const metadata = parseField(record.metadata, 'metadata', {})
  assertObject(metadata, 'metadata')
  const wrapper = metadata.config === undefined ? {} : metadata.config
  assertObject(wrapper, 'config')
  const detail = parseField(wrapper.detail, 'config.detail', {})
  assertObject(detail, 'config.detail')
  const config = persistentPageConfig(Object.assign({}, cloneConfig(defaults), detail))
  config.width = Number(config.width === undefined ? 1920 : config.width)
  config.height = Number(config.height === undefined ? 1080 : config.height)
  assertDimensions(config)
  config.backgroundColor = config.backgroundColor || '#1e1f1e'
  config.name = config.name || record.name || ''
  config.mark = Object.assign({}, cloneConfig(defaults.mark || {}), config.mark || {})
  config.query = config.query || {}
  config.deviceList = config.deviceList || []
  if (!Array.isArray(config.deviceList)) throw new LegacyConfigError('config.detail.deviceList', '必须是数组')
  const nodes = parseField(wrapper.component, 'config.component', [])
  assertNodes(nodes)
  const visual = metadata.visual === undefined ? {} : metadata.visual
  assertObject(visual, 'visual')
  return { record: cloneConfig(record), metadata, config, nodes, visual: cloneConfig(visual) }
}

export function createLegacyMetadata (metadata, config, nodes, options = {}) {
  assertObject(config, 'config.detail')
  assertDimensions(config)
  const base = cloneConfig(metadata || {})
  // 未知字段、组合、数据绑定与旧 scale 原样保留；编辑视口不写入业务配置。
  const detail = persistentPageConfig(cloneConfig(config))
  assertNodes(nodes)
  base.config = Object.assign({}, base.config, {
    id: options.id,
    visualId: options.id,
    detail: JSON.stringify(detail),
    component: JSON.stringify(nodes)
  })
  base.visual = Object.assign({}, base.visual, { id: options.id })
  if (options.coverUrl !== undefined) base.visual.backgroundUrl = options.coverUrl
  return base
}

export function createLegacySavePayload (record, metadata, config, nodes, options = {}) {
  const payload = {}
  // target不能被清空，visual密码/旧扩展字段也不能因保存被无意抹掉。
  for (const key of ['name', 'type', 'target', 'catalogId', 'state']) {
    if (record[key] !== undefined) payload[key] = cloneConfig(record[key])
  }
  payload.metadata = JSON.stringify(createLegacyMetadata(metadata, config, nodes, { ...options, id: record.id }))
  return payload
}
